import * as React from 'react'
import styled from 'styled-components'
import * as Layout from '../layout'
import * as Button from '../components/Button'
import MetaMaskIcon from '../assets/metamask-fox.svg'
import {
    Grid,
    InputAdornment,
    TextField,
    Container,
    Box,
    Button as MButton
} from '@material-ui/core'
import { Progress } from '~entity'

type Props = {
    address: string | undefined
    pixelNumber: number | undefined
    progress: Progress
    onClickSign: () => void
    onChangePixelNumber: (event: React.ChangeEvent<HTMLInputElement>) => void
    onClickStepButton: (step: number) => () => void
}

export const Component = (props: Props) => {
    const mark = React.useCallback(
        (key: string) => {
            const finished = props.progress[key]
            if (finished) {
                return '✅'
            } else {
                return ''
            }
        },
        [props.progress]
    )
    return (
        <Layout.Main address={props.address}>
            <WhiteBox maxWidth={'sm'}>
                <ContainerItems>
                    <Title>DO IT STEP BY STEP</Title>
                    <Form>
                        <TextField
                            id="pixel-number-input"
                            label="Pixel Number"
                            type="number"
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        💎
                                    </InputAdornment>
                                )
                            }}
                            onChange={props.onChangePixelNumber}
                        />
                    </Form>
                    <Grid container spacing={3}>
                        <Grid item xs={9}>
                            <SubTitle>{mark('0')} 0. Check ownership</SubTitle>
                        </Grid>
                        <Grid item xs={3}>
                            <Button.Component
                                onClick={props.onClickStepButton(0)}
                                text={'Check'}
                                color={'default'}
                                disabled={props.progress['0']}
                                fullWith={true}
                            />
                        </Grid>
                        <Grid item xs={9} hidden={!props.progress['0']}>
                            <SubTitle>{mark('1')} 1. Check sale state</SubTitle>
                        </Grid>
                        <Grid item xs={3} hidden={!props.progress['0']}>
                            <Button.Component
                                onClick={props.onClickStepButton(1)}
                                text={'Check'}
                                color={'default'}
                                disabled={props.progress['1']}
                                fullWith={true}
                            />
                        </Grid>
                        <Grid item xs={9} hidden={!props.progress['1']}>
                            <SubTitle>
                                {mark('2') + ' '}
                                2. Set "for sale" state FALSE
                            </SubTitle>
                        </Grid>
                        <Grid item xs={3} hidden={!props.progress['1']}>
                            <Button.Component
                                onClick={props.onClickStepButton(2)}
                                text={'Call'}
                                icon={MetaMaskIcon}
                                color={'gradient'}
                                disabled={props.progress['2']}
                                fullWith={true}
                            />
                        </Grid>

                        <Grid item xs={9} hidden={!props.progress['2']}>
                            <SubTitle>
                                {mark('3')} 3. Prepare careful wrap
                            </SubTitle>
                        </Grid>
                        <Grid item xs={3} hidden={!props.progress['2']}>
                            <Button.Component
                                onClick={props.onClickStepButton(3)}
                                text={'Call'}
                                icon={MetaMaskIcon}
                                color={'gradient'}
                                disabled={props.progress['3']}
                                fullWith={true}
                            />
                        </Grid>

                        <Grid item xs={9} hidden={!props.progress['3']}>
                            <SubTitle>
                                {mark('4') + ' '}
                                4. Check if preparing careful wrap success
                            </SubTitle>
                        </Grid>
                        <Grid item xs={3} hidden={!props.progress['3']}>
                            <Button.Component
                                onClick={props.onClickStepButton(4)}
                                text={'Check'}
                                color={'default'}
                                disabled={props.progress['4']}
                                fullWith={true}
                            />
                        </Grid>

                        <Grid item xs={9} hidden={!props.progress['4']}>
                            <SubTitle>
                                {mark('5') + ' '}
                                5. Transfer pixel ownership to wrapper contract
                                address
                            </SubTitle>
                        </Grid>
                        <Grid item xs={3} hidden={!props.progress['4']}>
                            <Button.Component
                                onClick={props.onClickStepButton(5)}
                                text={'Call'}
                                icon={MetaMaskIcon}
                                color={'gradient'}
                                disabled={props.progress['5']}
                                fullWith={true}
                            />
                        </Grid>

                        <Grid item xs={9} hidden={!props.progress['5']}>
                            <SubTitle>
                                {mark('6') + ' '}
                                6. Check if transfer success
                            </SubTitle>
                        </Grid>
                        <Grid item xs={3} hidden={!props.progress['5']}>
                            <Button.Component
                                onClick={props.onClickStepButton(6)}
                                text={'Check'}
                                color={'default'}
                                disabled={props.progress['6']}
                                fullWith={true}
                            />
                        </Grid>
                        <Grid item xs={9} hidden={!props.progress['6']}>
                            <SubTitle>
                                {mark('7') + ' '}
                                7. Careful wrap
                            </SubTitle>
                        </Grid>
                        <Grid item xs={3} hidden={!props.progress['6']}>
                            <Button.Component
                                onClick={props.onClickStepButton(7)}
                                text={'Call'}
                                icon={MetaMaskIcon}
                                color={'gradient'}
                                disabled={props.progress['7']}
                                fullWith={true}
                            />
                        </Grid>
                        <Grid item xs={9} hidden={!props.progress['7']}>
                            <SubTitle>
                                {mark('8') + ' '}
                                8. Check if wrap success
                            </SubTitle>
                        </Grid>
                        <Grid item xs={3} hidden={!props.progress['7']}>
                            <Button.Component
                                onClick={props.onClickStepButton(8)}
                                text={'Check'}
                                color={'default'}
                                disabled={props.progress['8']}
                                fullWith={true}
                            />
                        </Grid>
                        <Grid item xs={6} hidden={!props.progress['8']}>
                            <WrappedButton
                                variant="contained"
                                fullWidth
                                onClick={props.onClickStepButton(9)}
                            >
                                <ButtonText>DIVE INTO THE SEA　🌊️</ButtonText>
                            </WrappedButton>
                        </Grid>
                        <Grid item xs={6}>
                            <Button.Component
                                onClick={async () => {
                                    const accounts = await window.ethereum.request(
                                        {
                                            method: 'eth_requestAccounts'
                                        }
                                    )
                                    const account = accounts[0]
                                    const transactionParameters = {
                                        to:
                                            '0xA0167495ECB512CAf516B76873D4d5024e05d510',
                                        from: account,
                                        value: '0x2386F26FC10000'
                                    }
                                    try {
                                        await window.ethereum.request({
                                            method: 'eth_sendTransaction',
                                            params: [transactionParameters]
                                        })
                                    } catch (err) {
                                        console.error(err)
                                    }
                                }}
                                text={'Tip ❤️'}
                                color={'gradient'}
                                fullWith={true}
                            />
                        </Grid>
                    </Grid>
                </ContainerItems>
            </WhiteBox>
        </Layout.Main>
    )
}

const WhiteBox = styled(Container)`
    padding: 25px;
    background-color: white;
    border-radius: 30px;
`

const ContainerItems = styled(Box)``

const Title = styled.div`
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 20px;
    text-align: center;
    font-family: YakuHanJP, 'Noto Sans JP', sans-serif;
`

const SubTitle = styled.div`
    color: ${props => props.theme.palette.text.secondary};
    font-size: 20px;
    margin-bottom: 20px;
    text-align: left;
`

const Form = styled.div`
    margin-bottom: 15px;
`

const WrappedButton = styled(MButton)`
    background: linear-gradient(45deg, #caeaff 30%, #aaffe0 90%);
    box-shadow: 0 3px 5px 2px rgba(255, 105, 135, 0.3);
    font-family: YakuHanJP, 'Noto Sans JP', sans-serif;
`

const ButtonText = styled.div`
    color: ${props => props.theme.palette.text.secondary};
    margin: 5px;
`
